

import * as React from 'react';

import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';
// import { AppBar, Toolbar, Typography } from '@material-ui/core';

// import { BasketIcon } from './app/ReduxBasket';
// import FlagIcons from './app/FlagIcons';

import { connect } from 'react-redux';

import { AppState, Actions, store, IPageState, PanelState } from '../../appredux';



import CONFIG from '../../cfg/config';

import { Info, obiektService, Result, ObiectRoomNumer } from '../../api';

import { daysFromDate,/*, shallowEqual*/ 
sendErrorLog} from '../../app/common/helpers';
import NumeramiGrafik from './NumeramiGrafik';
import { GRAFIK_DNI } from 'App';

interface RezerwacjeNumeryProps {
  page: IPageState,
  expanded: boolean,
  windowWidth: number
}

interface RezerwacjeNumeryStateInterface {
  loadingGraphic: boolean,
  graphic: ObiectRoomNumer[],
}

class RezerwacjeNumery extends React.Component<RezerwacjeNumeryProps & WithStyles<typeof styles>, RezerwacjeNumeryStateInterface> {

  //PM 2021-03-11
  constructor(props: RezerwacjeNumeryProps & WithStyles<typeof styles>) {
    super(props, {});


    this.state = {
      loadingGraphic: true,
      graphic: [],
    }
  }



  //PM 2021-03-11
  async componentDidMount() {
    await this.getGraphicData();
  }

  async componentDidUpdate(prevProps: RezerwacjeNumeryProps) {
    if (this.props.page.dateFrom !== prevProps.page.dateFrom || this.props.page.grafikRefresh !== prevProps.page.grafikRefresh) {
      await this.getGraphicData();
    } else if (prevProps.page.state == PanelState.psReservPending && this.props.page.state == PanelState.psBrowse) {
      await this.getGraphicData();
    }
  }

  //PM 2021-03-11
  async getGraphicData() {
    this.setState({ loadingGraphic: true });

    const filtrDateF = this.props.page.dateFrom;
    const filtrDateT = daysFromDate(new Date(filtrDateF), GRAFIK_DNI);

    const json = {
      dataOd: this.props.page.dateFrom,
      dataDo: daysFromDate(new Date(this.props.page.dateFrom), GRAFIK_DNI),
      domena: this.props.page.lang,
      opisNoclegi: 0,

      filtrIloscDni: Number(1),
      filtrIloscOsob: Number(1),
      filtrRodzNoclegu: Number(1),
      filtrDataOd: filtrDateF,
      filtrDataDo: filtrDateT
    }
    //console.log(json)
    //console.log(JSON.stringify(json))
    try {
      const res: Result<ObiectRoomNumer> = await obiektService.dajGrafikObiektPokoje({
        hotelId: CONFIG.hotelID,
        json: json
        //dataOd: this.props.page.dateFrom, 
        //dataDo: dateTo,
        //domena: this.props.page.lang
      }, {})
      //console.log(res.result)

      store.dispatch(Actions.pageState.updateGrafikNumery(res.result));
      this.setState({ graphic: res.result, loadingGraphic: false });
    } catch (error) {
      await sendErrorLog("0", "-1", '/obiekt/dajGrafikObiektPokoje')
      await store.dispatch(Actions.pageState.addFcmLogMessage("/obiekt/dajGrafikObiektPokoje", 2))
      console.log(error)
      //console.log(error)
    }
  }

  //PM 2021-05-27
  onWroc = async () => {
    await this.getGraphicData();
  }

  //PM 2021-05-27
  render() {
    //console.log(this.state.graphic)

    return (
      <NumeramiGrafik
        windowWidth={this.props.windowWidth}
        loading={this.state.loadingGraphic}
        data={this.state.graphic}
        expanded={this.props.expanded} 
        onWroc={this.onWroc}
      />
    );
  }
}

const styles = (theme: Theme) => ({
});

const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withStyles(styles)(RezerwacjeNumery));
